<template>
  <v-card id="progress-button">
    <v-card-title>
      State
    </v-card-title>
    <v-card-text>
      <EventState />
    </v-card-text>
    <v-card-actions>
      <v-dialog
        v-if="eventState !== 'Completed'"
        v-model="progressDialog"
        width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
          >
            Progress State
          </v-btn>
        </template>
        <v-card>
          <v-card-text>
            <v-container>
              The state can never go backwards, so be careful!
            </v-container>
          </v-card-text>
          <v-divider />
          <v-card-actions>
            <v-btn
              text
              @click="() => { progressDialog = false }"
            >
              Cancel
            </v-btn>
            <v-spacer />
            <v-btn
              text
              @click="progressState"
            >
              Progress
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-actions>
  </v-card>
</template>

<script>
import AdminClient from '@/api/AdminClient';
import EventsClient from '@/api/EventsClient';
import EventState from '@/components/EventState.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ProgressButton',
  components: {
    EventState,
  },
  data() {
    return {
      eventId: this.$store.state.hackathonID,
      progressDialog: false,
    };
  },
  computed: {
    ...mapGetters({
      currentJwtToken: 'currentJwtToken',
      currentUser: 'currentUser',
      eventState: 'eventState',
    }),
  },
  methods: {
    ...mapActions({
      setEvent: 'setEvent',
    }),
    async progressState() {
      const adminClient = new AdminClient(this.currentJwtToken);
      const eventsClient = new EventsClient(this.currentJwtToken);
      await adminClient.progressState(this.eventId);
      const updatedEvent = await eventsClient.getEvent(this.eventId);
      this.setEvent(updatedEvent);
      this.progressDialog = false;
    },
  },
};
</script>
